import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXkY916r_0rPD7MqTvhs6H_exOVus4yBE",
  authDomain: "christian-360.firebaseapp.com",
  projectId: "christian-360",
  storageBucket: "christian-360.firebasestorage.app",
  messagingSenderId: "930159352432",
  appId: "1:930159352432:web:8537d1f8050024f676f2b5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and export it
export const auth = getAuth(app);

// --- Authentication Providers ---

// Create and export a Google Auth Provider instance
export const googleProvider = new GoogleAuthProvider();

// Create and export an Apple Auth Provider instance
export const appleProvider = new OAuthProvider('apple.com');

export default app; 